import { render, staticRenderFns } from "./workIndManFill.vue?vue&type=template&id=2b79bb20&scoped=true&"
import script from "./workIndManFill.vue?vue&type=script&lang=js&"
export * from "./workIndManFill.vue?vue&type=script&lang=js&"
import style0 from "./workIndManFill.vue?vue&type=style&index=0&id=2b79bb20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b79bb20",
  null
  
)

export default component.exports